import { registerAction } from '../../Action'

const CLOSE_FILTERS_TRAY = 'CLOSE_FILTERS_TRAY'

const reducer = (state = {}) => ({
  ...state,
  filters: {
    ...state.filters,
    isTrayOpen: false,
  },
})

const closeFiltersTray = registerAction(CLOSE_FILTERS_TRAY, { reducer })

export default closeFiltersTray
